import { attachComponent } from 'algu-domain'

import { finalizeButtonComponent, memoEval, propertyPageComponent } from '@salsita-ai/platform-project-sdk/domain'

import { FinalizeButton } from '../ui-components/FinalizeButton'
import { TablePropertyPage } from '../ui-components/property-pages/TablePropertyPage'

export const tableComponents = [
  attachComponent
    .withEntity('Table')
    .withComponent(finalizeButtonComponent, 'main')
    .attach(
      memoEval(
        () => [],
        () => ({
          button: <FinalizeButton />,
        })
      )
    ),
  attachComponent
    .withEntity('Table')
    .withComponent(propertyPageComponent, 'main')
    .attach(
      memoEval(
        s => [s.id, s.$legs, s.$top],
        (id, $legs, $top) => ({
          page: <TablePropertyPage id={id} $legs={$legs} $top={$top} />,
        })
      )
    ),
]
